import { elements, state } from './config';

// Anchor the search overlay just below the navbar bar. A top banner
// (.site-banner--top) of variable height pushes the navbar down, so measure the
// navbar's actual bottom edge; CSS falls back to 0 when this isn't set.
// Re-run on resize (a dismissed banner also fires resize) so it follows the bar.
function updateSearchTop(): void {
    if (!elements.navbar) {
        return;
    }

    const navbarBottom = Math.max(0, elements.navbar.getBoundingClientRect().bottom);
    elements.body.style.setProperty('--mp-search-top', `${navbarBottom}px`);
}

export function openSearch(isBlogSearch: boolean = false): void {
    if (!elements.searchLandingPage) {
        return;
    }

    state.isSearchOpen = true;

    const queryInput = elements.searchLandingPage.querySelector<HTMLInputElement>('input[name=query]');
    const blogSuggestions = elements.searchLandingPage.querySelector<HTMLElement>('#blog-suggestions');
    const pageSuggestions = elements.searchLandingPage.querySelector<HTMLElement>('#page-suggestions');
    const searchTypeInput = elements.searchLandingPage.querySelector<HTMLInputElement>('input[name=search-type]');

    const typeValue: string = isBlogSearch ? 'blog' : 'pages';
    const placeholder: string = queryInput ? (isBlogSearch ? queryInput.dataset.placeholderBlog : queryInput.dataset.placeholderPages) ?? '' : '';
    
    if (blogSuggestions) {
        blogSuggestions.style.display = isBlogSearch ? 'block' : 'none';
    }

    if (pageSuggestions) {
        pageSuggestions.style.display = isBlogSearch ? 'none' : 'block';
    }

    if (searchTypeInput) {
        searchTypeInput.value = typeValue;
    }

    if (queryInput) {
        queryInput.placeholder = placeholder || '';
    }

    elements.body.classList.remove('mp-navbar-mobile-visible');
    elements.searchLandingPage.classList.add('visible');
    elements.searchLandingPage.setAttribute('aria-hidden', 'false');

    updateSearchTop();
    window.addEventListener('resize', updateSearchTop);

    setTimeout(() => {
        elements.body.classList.add('search-landing-page--visible');
        const searchInput = document.getElementById('search-landing') as HTMLInputElement | null;

        if (searchInput) {
            searchInput.value = '';
            searchInput.focus();
        }
    }, 0);
}

export function closeSearch(): void {
    if (!elements.searchLandingPage) {
        return;
    }

    state.isSearchOpen = false;
    elements.body.classList.remove('search-landing-page--visible');
    elements.searchLandingPage.classList.remove('visible');
    elements.searchLandingPage.setAttribute('aria-hidden', 'true');
    elements.body.style.removeProperty('--mp-search-top');
    window.removeEventListener('resize', updateSearchTop);
}

export function initSearch(): void {
    if (elements.searchLandingPage) {
        elements.searchLandingPage.setAttribute('aria-hidden', 'true');
    }
}